import { useLaunchpadProvider } from '@trustpad/launchpad';
import { UserTierState } from '@trustpad/launchpad/dist/tiers/hooks/useUserTier';
import { FaCheck } from 'react-icons/fa';
import { Popup } from '~common/components/Popup';
import { levelPools } from '~config/levelPoolsConfig';
import { getAllocationBooster } from '~features/tiers/utils';

const On = () => <FaCheck className="text-green-500 inline-block w-6" />;
const Off = () => <span className="inline-block w-6 text-center">❌</span>;

// This could be added below Your perks section:
//
//   Your personal stats
//
// Your share of this pool: 1.34%
// Your ranking in this pool: 2nd / 1 231
//
// When people see that their percentage goes down, they know that they need to stake more, they don't want to lose their share. It is basic psychology. 😎
export function UserTierPerksOverview({
  tierState,
  maxPoolId,
}: {
  tierState: UserTierState;
  maxPoolId: string;
}) {
  const { levels } = useLaunchpadProvider();
  const isAAG = tierState.tier.aag;
  const booster = getAllocationBooster(
    tierState.tier.multiplier,
    levels[tierState.tierId].multiplier,
  );
  const pool = levelPools.find((v) => v.id === maxPoolId);

  return (
    <div className="text-gray-100 space-y-3">
      <div>
        {tierState.tier.random || tierState.tier.multiplier === 0 ? (
          <>
            <Off /> No guaranteed allocations on IDOs and INOs.
          </>
        ) : (
          <>
            <On /> Guaranteed allocations for the IDOs and INOs.
          </>
        )}
      </div>
      <div>
        {booster > 0 ? (
          <>
            <On />{' '}
            <span className="brand-text font-medium text-xl">+{booster}%</span>{' '}
            Allocation Booster is on!{' '}
            {!isAAG && 'Stake an AAG tier to get a higher booster.'}
          </>
        ) : (
          <>
            <Off /> <span>Allocation booster is off. </span>
            <Popup header="Allocation Booster eligibility">
              Stake a tier in the 30-day (or longer) pool to receive an
              allocation booster.
            </Popup>
          </>
        )}
      </div>
      <div>
        {isAAG ? (
          <>
            <On /> All-Access Guaranteed (AAG) allocations, access also to seed,
            private, strategic, etc. sales.
          </>
        ) : (
          <>
            <Off />{' '}
            <span>
              No All-access Guaranteed (AAG) allocations. No access to seed,
              private, strategic, etc. sales.
            </span>{' '}
            <Popup
              btnClassName="inline-block"
              header="SAAG & AAG special perks & rewards">
              The allocation boosters are available from the 30-day pool upward,
              but the AAG and SAAG echelon special perks and rewards are only
              available in the 365, 730 and 1095-day staking pools.
            </Popup>
          </>
        )}
      </div>
      {tierState.tier.multiplier > 0 && (
        <div>
          {tierState.tier.random ? (
            <>
              <On /> Access to sales FCFS
            </>
          ) : (
            <></>
          )}
        </div>
      )}
      {pool?.lockPeriodSeconds >= 365 * 24 * 3600 && (
        <div>
          <On /> Free Airdrops in TrustPad VIP/Incubated projects.
        </div>
      )}
    </div>
  );
}
